var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7041 0.454103C10.5992 0.558619 10.516 0.682811 10.4592 0.819556C10.4024 0.956302 10.3732 1.10291 10.3732 1.25098C10.3732 1.39904 10.4024 1.54565 10.4592 1.6824C10.516 1.81914 10.5992 1.94334 10.7041 2.04785L15.5312 6.87504L1.74999 6.87504C1.45162 6.87504 1.16548 6.99357 0.954496 7.20455C0.743519 7.41552 0.624992 7.70167 0.624992 8.00004C0.624992 8.29841 0.743519 8.58456 0.954496 8.79554C1.16548 9.00651 1.45162 9.12504 1.74999 9.12504H15.5312L10.7041 13.9541C10.4927 14.1654 10.374 14.4521 10.374 14.751C10.374 15.0499 10.4927 15.3365 10.7041 15.5479C10.9154 15.7592 11.202 15.8779 11.5009 15.8779C11.7998 15.8779 12.0865 15.7592 12.2978 15.5479L19.0478 8.79785C19.1527 8.69334 19.2359 8.56915 19.2927 8.4324C19.3495 8.29565 19.3787 8.14904 19.3787 8.00098C19.3787 7.85291 19.3495 7.7063 19.2927 7.56956C19.2359 7.43281 19.1527 7.30862 19.0478 7.2041L12.2978 0.454103C12.1933 0.349223 12.0691 0.266006 11.9324 0.209226C11.7956 0.152445 11.649 0.123215 11.5009 0.123215C11.3529 0.123215 11.2063 0.152445 11.0695 0.209226C10.9328 0.266006 10.8086 0.349223 10.7041 0.454103Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right Arrow.75c880fce1390b1cb7f622a33cf84c9a.svg";
export { ForwardRef as ReactComponent };